import React from 'react';
import NSDDashboardDesktop from './NSDDashboardDesktop/NSDDashboardDesktop';

const NSDDashboardContainer = () => {
  // maybe some extra logic here
  return <NSDDashboardDesktop />;
};

export default NSDDashboardContainer;
